// extracted by mini-css-extract-plugin
export default {"root":"SingleSelectFormContent_root__8MFpO","choicesHeader":"SingleSelectFormContent_choicesHeader__zKwdH"};